import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { AppResource } from 'src/app/app.resource';

@Component({
  selector: 'app-error404',
  templateUrl: './error404.component.html',
  standalone: true,
  imports: [CommonModule],
})
export class Error404Component extends BaseComponent implements OnInit, OnDestroy {
  constructor(resources: AppResource) {
    super(resources);

    this.store.updateSizeXL(true);
    this.store.updateBreadcrumb(false);
    this.store.updateVerticalAlign(true);
    this.store.updateHeader(false);
  }

  override ngOnInit() {}

  ngOnDestroy(): void {
    this.store.updateSizeXL(false);
    this.store.updateBreadcrumb(true);
    this.store.updateVerticalAlign(false);
    this.store.updateHeader(true);
  }
}
